import timer from '@devices/settings/device_settings/timer.js';
import schedule from '@devices/settings/device_settings/schedule.js';
import actions from '@devices/settings/device_settings/actions.js';
import internet from '@devices/settings/device_settings/internet.js';
import app_setting_bulb_rgbw_gen_2 from '@devices/settings/common_settings/app_setting_bulb_rgbw_gen_2.js';
import share from '@devices/settings/device_settings/share.js';

export default {
	name: 'shellybulb',
	friendly_name: 'Bulb 1',
	family: 'light',
	isPM: false,
	modes: {
		color: {
			availableViews: ['basic'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'forgotten_lights'],
			slider: 'gain',
			gain: 0,
			color_temp: { minValue: 3000, maxValue: 6500 },
			color: true,
			effects: [
				{ label: 'OFF', id: 0 },
				{ label: 'METEOR SHOWER', id: 1 },
				{ label: 'GRADUAL CHANGE', id: 2 },
				{ label: 'FLASH', id: 3 },
				{ label: 'BREATH', id: 4 },
				{ label: 'ON/OFF GRADUAL', id: 5 },
				{ label: 'RED/GREEN CHANGE', id: 6 },
			],
			settings: [
				timer,
				schedule,
				actions,
				internet,
				app_setting_bulb_rgbw_gen_2,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
		white: {
			availableViews: ['basic'],
			channels: 1,
			slider: 'brightness',
			brightness: 0,
			color_temp: { minValue: 3000, maxValue: 6500 },
			color: true,
			effects: [
				{ label: 'OFF', id: 0 },
				{ label: 'METEOR SHOWER', id: 1 },
				{ label: 'GRADUAL CHANGE', id: 2 },
				{ label: 'FLASH', id: 3 },
				{ label: 'BREATH', id: 4 },
				{ label: 'ON/OFF GRADUAL', id: 5 },
				share,
				{ label: 'RED/GREEN CHANGE', id: 6 },
			],
			settings: [
				timer,
				schedule,
				actions,
				internet,
				{
					title: 'application_settings',
					components: [
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'pin_lock', component: 'pin_lock' },
						{ title: 'exclude_event_log', component: 'exclude_event_log' },
					],
				},
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode' },
						{ title: 'power_on_default', component: 'power_on_default' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{
							title: 'geo_location_and_time_zone',
							component: 'geo_location_and_time_zone',
						},
						{ title: 'device_name', component: 'device_name' },
						{ title: 'factory_reset', component: 'factory_reset_g1' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
